import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  container: {
    // flex: 1,
    marginHorizontal: 4
  },
  fit: {
    marginLeft: 20,
    marginRight: 20,
  },
  above: {
    zIndex: 2000,
  },
  rechercheTextInput: {
    marginLeft: 20,
    flex: 1,
  },
  input: {
    borderColor: 'black',
    borderWidth: 1,
    marginTop: 10,
    marginBottom: 5,
    borderRadius: 4,
    height: 50,
  },
  label: {
    fontSize: 16,
    fontWeight: 'normal',
    color: 'black',
  },
  title: {
    fontSize: 16,
    fontWeight: 'normal',
    color: 'black',
  },
  normalTitle: {
    marginRight: 20,
    marginLeft: 20,
    fontSize: 16,
    fontWeight: 'normal',
    color: 'black',
  },
  pageTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#000',
  },
  mainTitle: {
    fontSize: 18,
    fontWeight: '700',
    color: 'rgba(15, 87, 158, 1)',
    marginTop: 24,
    marginBottom: 8,
  },
  secondTitle: {
    fontSize: 18,
    fontWeight: '700',
    color: '#000',
  },
  thirdTitle: {
    fontSize: 16,
    fontWeight: '700',
    color: '#000',
  },
  titleGreen: {
    fontSize: 18,
    fontWeight: '700',
    color: '#1D5C42',
    minHeight: 25,
    marginTop: 16,
  },
  titleGreenCross: {
    fontSize: 18,
    fontWeight: '700',
    color: '#1D5C42',
    marginTop: 20,
  },
  titleGreenCenter: {
    fontSize: 18,
    fontWeight: '700',
    color: '#1D5C42',
    textAlign: 'center',
  },
  titleGreen14: {
    fontSize: 14,
    fontWeight: '700',
    color: '#1D5C42',
  },
  titleGreen11: {
    fontSize: 11,
    fontWeight: '700',
    color: '#1D5C42',
  },
  titleGreen12: {
    fontSize: 12,
    fontWeight: '700',
    color: '#1D5C42',
  },
  titleGreen13: {
    fontSize: 13,
    fontWeight: '700',
    color: '#1D5C42',
  },
  titleBlue: {
    fontSize: 16,
    fontWeight: '700',
    color: '#0F579E',
  },
  paragraph: {
    fontSize: 16,
    fontWeight: '400',
    color: '#000',
    marginVertical: 16
  },
  paragraph14: {
    fontSize: 14,
    fontWeight: '400',
    color: '#000',
    marginVertical: 8
  },
  link: {
    fontSize: 16,
    fontWeight: '700',
    color: '#58A618',
    marginVertical: 16
  },
  error: {
    fontSize: 14,
    fontWeight: '400',
    color: '#F00',
  },
  linkblue: {
    fontSize: 16,
    fontWeight: '700',
    color: '#0F579E',
    marginVertical: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#0F579E',
  },
  linkUnderline: {
    fontSize: 16,
    fontWeight: '400',
    color: '#58A618',
    marginVertical: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#58A618',
  },
  validate: {
    backgroundColor: '#23a4ea',
    minWidth: 120,
    // backgroundColor: '#000',
  },
  inValidate: {
    minWidth: 120,
    backgroundColor: 'gray',
    color: 'black',
  },
  textError: {
    color: '#f00',
    fontSize: 14,
  },
  appButtonContainer: {
    flexDirection: 'row',
    marginVertical: 4,
    marginRight: 4,
    marginLeft: 4,
    color: '#fff',
    borderRadius: 5,
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    height: 50,
  },
  appButtonContainerBtn: {
    minWidth: 120,
    margin: 15,
    color: '#fff',
    padding: 10,
    borderRadius: 5,
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    height: 50,
  },
});
